<template>
    <div class="consultation-header">
        <div class="header-first">
            <div style="text-align:center;font-family: Microsoft YaHei;font-weight: bold;color: #272727;margin-top:15px;font-size:22px"><span>远程门诊</span></div>
        </div>
        <div class="header-second">
            <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px"><span>产品简介</span></div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;margin-top:20px;text-indent:30px;"> 远程门诊是结合上级医院的专家资源与就近便利就医的一种医疗服务方式。上级医院可以设置专家的远程门诊排班时间，基层患者可通过手机或在基
        </div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px">层医院进行线上的门诊挂号。 按照挂号时间，患者到所在基层医院进行远程门诊视频沟通， 门诊后专家出具诊断报告，基层医院确定并完成远程门诊。
        </div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px;text-indent:30px;">通过远程门诊服务可以提高患者在基层医疗机构的就诊质量，方便患者就医，减少患者就医成本和就医时间，缓解大医院的接诊压力，促进优质医疗</div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px;">资源下沉，有效缓解百姓“看病难，看病贵”的问题。</div>
            <div style="margin-top:25px">
                <img src="@/assets/image/menzhen.png" alt="">
            </div>
        </div>
        <div class="header-firth" style="margin-top:15px">
            <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px"><span>业务流程</span></div>
            <div>
                <img src="@/assets/image/menzhen1.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss">
    .consultation-header{
        width: 100%;
        padding-left: 20px;
        .header-forth{
            margin-right:70px;
        }

    }
</style>